module.exports = __webpack_public_path__ + "static/media/12_the-urban-farm-sending-meals-to-children.db592768.jpg";